import React, { useState } from 'react';
import { format, addDays } from 'date-fns';
import { Calendar } from 'lucide-react';
import { hebrewDayNames } from '../utils/dates';

interface DatePickerProps {
  selectedDate: Date;
  onDateSelect: (date: Date) => void;
}

export const DatePicker: React.FC<DatePickerProps> = ({ selectedDate, onDateSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const dates = Array.from({ length: 7 }, (_, i) => {
    const date = addDays(new Date(), i);
    return {
      date,
      label: i === 0 ? 'היום' : 
             i === 1 ? 'מחר' : 
             format(date, 'dd/MM'),
      dayName: hebrewDayNames[format(date, 'EEEE') as keyof typeof hebrewDayNames],
      isToday: i === 0
    };
  });

  const selectedDateLabel = format(selectedDate, 'dd/MM');
  const selectedDayName = hebrewDayNames[format(selectedDate, 'EEEE') as keyof typeof hebrewDayNames];
  const isToday = selectedDate.toDateString() === new Date().toDateString();

  return (
    <div className="w-full bg-white rounded-lg">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 rounded-lg bg-slate-50 hover:bg-slate-100 transition-colors"
      >
        <div className="flex items-center gap-3">
          <Calendar size={20} className="text-slate-600" />
          <div className="text-right">
            <div className="font-medium text-slate-800">
              {isToday ? 'היום' : selectedDateLabel}
            </div>
            <div className="text-sm text-slate-500">
              יום {selectedDayName}
            </div>
          </div>
        </div>
        <div className="text-slate-400">
          {isExpanded ? '▼' : '▶'}
        </div>
      </button>

      {isExpanded && (
        <div className="mt-2 grid grid-cols-4 gap-2 p-2 bg-white rounded-lg shadow-sm border border-slate-100">
          {dates.map(({ date, label, dayName }) => (
            <button
              key={date.toISOString()}
              onClick={() => {
                onDateSelect(date);
                setIsExpanded(false);
              }}
              className={`
                p-3 rounded-lg text-center transition-colors
                ${date.toDateString() === selectedDate.toDateString()
                  ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
                  : 'hover:bg-slate-50'
                }
              `}
            >
              <div className="text-sm font-medium">
                {label}
              </div>
              <div className="text-xs text-slate-500 mt-1">
                יום {dayName}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};